<script setup>
import { onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const store = useStore();
const route = useRoute();

onMounted(() => {
  store.dispatch('campaigns/get', { include_schedules: true });
  store.dispatch('labels/get');
});
</script>

<template>
  <div
    class="flex flex-col justify-between flex-1 min-w-0 m-0 bg-n-background"
  >
    <router-view v-slot="{ Component }">
      <!-- max: a chave é a URL inteira (cada query vira outra instância em
           cache) — sem teto, cada visita com filtro diferente deixava mais uma
           tela viva na memória. -->
      <keep-alive v-if="keepAlive" :max="5">
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
      <component :is="Component" v-else />
    </router-view>
  </div>
</template>
